module.exports = __webpack_public_path__ + "06.jpg?dba768d4f6c08d81db6a64535f4f3bde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/06.jpg
// module id = 153
// module chunks = 0